import { memo } from 'react';
import {
  Grid, Stack, Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { RoundedMedia } from '@client/components/common/Media';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { HomeSection } from '@client/components/common/HomeSection';
import type { TypographyProps } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  image: {
    borderRadius: theme.radii.large,
    boxShadow: theme.shadows[4],
    overflow: 'hidden',
  },
  imageContainer: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));

interface SectionProps {
  readonly title: string;
  readonly description: string;
  readonly imgSrc: string;
  readonly button?: React.ReactNode;
  readonly titleVariant?: TypographyProps['variant'];
}

export const Section = memo<SectionProps>(({
  title, description, imgSrc, button: ButtonComponent,
  titleVariant = 'h6',
}) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <HomeSection>
      <div>
        <Grid
          container
          spacing={isMobile ? 3 : 6}
          direction={isMobile ? 'column-reverse' : 'row'}
          alignItems="center"
        >
          <Grid
            item
            md={4}
          >
            <Stack spacing={3}>
              <Stack spacing={2}>
                <Typography
                  variant={titleVariant}
                  sx={{ color: 'secondary.dark' }}
                >
                  {title}
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{ color: 'secondary.dark' }}
                >
                  {description}
                </Typography>
              </Stack>

              {Boolean(ButtonComponent) && (
                <div>
                  {ButtonComponent}
                </div>
              )}
            </Stack>
          </Grid>

          <Grid
            item
            md={8}
            className={classes.imageContainer}
          >
            <RoundedMedia
              title={title}
              images={imgSrc}
              className={classes.image}
            />
          </Grid>
        </Grid>
      </div>
    </HomeSection>
  );
});
